import React from 'react'
import '../components/EtNow/opigo.css'
import ParticleCanvas from '../components/EtNow/ParticleCanvas.jsx'
const Home = () => {
  const goToETNow = () => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

    const url = isMobile
      ? 'https://onelink.to/m4v2k3'
      : 'https://onelink.to/r5fdp3'

    window.open(url, '_blank')
  }

  const toggleFAQ = (e) => {
    e.currentTarget.closest('.faq-item').classList.toggle('open')
  }

  const adminOpigo = () => {
    window.location.href = 'https://www.etnownews.com/'
  }

  const scrollToAnnouncement = () => {
    const element = document.querySelector('.announcement')
    if (element) {
      const headerOffset = 60
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  return (
    <>
      {/* NAV */}
      <nav>
        <div className='nav-inner'>
          <div className='logo'>
            <img src='/Logo.svg' alt='OpiGo' height={26} />
          </div>{' '}
          <button className='nav-cta' onClick={goToETNow}>
            Continue to ET Now
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className='hero'>
        <ParticleCanvas />
        <div className='hero-container'>
          <span className='hero-badge'>Announcement 🎉</span>
          <h1>We have a new Home.</h1>
          <p>
            OpiGo is now part of ET Now following its acquisition by The Times
            Group, India’s largest media conglomerate.
          </p>

          <div className='hero-ctas'>
            <button className='btn-new btn-primary' onClick={goToETNow}>
              Continue to ET Now
            </button>
            <button
              className='btn-new btn-secondary'
              onClick={scrollToAnnouncement}
            >
              Read the announcement
            </button>
          </div>
        </div>
      </section>

      {/* ANNOUNCEMENT */}
      <section className='announcement'>
        <div className='container'>
          <div className='announcement-grid'>
            {/* Left: Text */}
            <div className='announcement-text'>
              <div className='announcement-label'>The News</div>
              <p>
                OpiGo, India’s leading marketplace for SEBI-registered experts,
                has been acquired by The Times Group to strengthen ET Now’s
                fintech ecosystem.
              </p>{' '}
              <br />
              <p>
                The combined platform will serve as a comprehensive investing
                destination for Indian retail investors, integrating expert
                analysis, community insights, market data, and actionable
                trading calls in a single interface. Over the coming months,
                OpiGo will be fully integrated into ET Now's ecosystem, with
                plans to expand fintech offerings, enhance broker integrations,
                and develop new community features tailored to India's retail
                investor base.
              </p>
              <div className='founder-vision'>
                <div className='vision-header'>
                  <img src='/DP.jpg' alt='Founder' className='founder-logo' />
                  <h4 className='vision-title'>Devansh Mehta, Founder</h4>
                </div>

                <p className='body-md'>
                  We built OpiGo because we believed retail India deserved
                  better. Today, that belief gets amplified by Times Group's
                  decades of market authority.
                </p>
              </div>
            </div>

            {/* Right: Image */}
            <div className='announcement-visual'>
              <img
                src='/the_news.png'
                alt='Announcement Visual'
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '16px',
                }}
              />
            </div>
          </div>
        </div>
      </section>
      {/* TIMELINE */}
      <section className='timeline-section'>
        <div className='container'>
          <h2>The Journey So Far</h2>

          <div className='timeline'>
            <div className='timeline-grid'>
              {[
                {
                  year: '2023',
                  text: "Launched India's first score-linked investor community Scaled to 10,000 organic users",
                },
                {
                  year: '2024',
                  text: 'Raised ₹1.4 Cr from leading angel investors Scaled the community to 50,000 users',
                },
                {
                  year: '2025',
                  text: 'Launched the SEBI expert marketplace Onboarded 30+ experts and integrated 15 brokers',
                },
                { year: '2026', text: 'Acquired by The Times Group' },
              ].map((item, i) => (
                <div className='timeline-item' key={i}>
                  <div className='timeline-dot'></div>
                  <div className='timeline-year'>{item.year}</div>
                  <div className='timeline-event'>{item.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className='faq-section'>
        <div className='faq-container'>
          <h2>Questions you might have</h2>

          <div className='faq-list'>
            {[
              {
                q: 'What happens to my OpiGo account?',
                a: 'Your OpiGo account will seamlessly move to ET Now. Simply sign in using the same mobile number to continue your journey.',
              },
              {
                q: 'What happens to my subscription?',
                a: 'Your active subscription will be upgraded on ET Now. While your existing tenure remains unchanged, you’ll now get platform-wide access to all experts instead of your single expert subscription.',
              },
              {
                q: 'When will this transition happen?',
                a: 'The OpiGo app will continue to function normally over the coming weeks. We’ll notify you well in advance before any changes take place.',
              },
              {
                q: 'Is my data safe?',
                a: 'Yes. Your data continues to remain secure and protected under the privacy and security standards of The Times Group.',
              },
              {
                q: 'Why has the WhatsApp chat name changed?',
                a: 'As part of the transition, the OpiGo WhatsApp support channel will now appear as “ET Now Pro.” Don’t worry — the ET Now team will continue to assist you with all queries related to your OpiGo account and migration to ET Now.',
              },
              {
                q: 'I still have questions. How can I reach out?',
                a: (
                  <>
                    You can reach out to our team on ET Now WhatsApp for any
                    help. Click on this link to connect with us.
                    <a
                      href='https://wa.link/dmwyyz'
                      target='_blank'
                      rel='noopener noreferrer'
                      style={{ color: '#6c63ff', fontWeight: 600 }}
                    >
                      https://wa.link/dmwyyz
                    </a>
                  </>
                ),
              },
            ].map((item, i) => (
              <div className='faq-item' key={i}>
                <div className='faq-question' onClick={toggleFAQ}>
                  <span>{item.q}</span>
                  <span className='faq-toggle'>+</span>
                </div>

                <div className='faq-answer'>{item.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className='final-cta'>
        <ParticleCanvas />
        <div className='final-cta-container'>
          <h2>Thank you for being a part of our journey.</h2>

          <div className='final-cta-buttons'>
            <button className='btn-new btn-light' onClick={goToETNow}>
              Download ET Now App
            </button>
            <button className='btn-new btn-outline' onClick={adminOpigo}>
              Visit ET Now Website
            </button>
          </div>

          {/* <p>
            For anything else, write to <a>admin@opigo.in</a>.
          </p> */}
        </div>
      </section>

      {/* FOOTER */}
      <footer>OpiGo is a part of ET Now (Times Network).</footer>
    </>
  )
}

export default Home
